/* eslint-disable jsx-a11y/label-has-associated-control */
import moment from 'moment-timezone';
import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';

import { setObservation } from '../../app/store/actions/cart';
import CartUtil from '../../app/utils/cart';
import inputs from '../../data/inputs';
import NUMBER from '../../helpers/number';
import CartTableItem from '../cart/CartTableItem';
import PriceComponent from '../price/Price';

function getPaymentLabel(type) {
  switch (type) {
    case 'credit':
      return I18n.t('credit');
    case 'debit':
      return I18n.t('debit');
    case 'bank_slip':
      return I18n.t('bankSlip');
    case 'estimate':
      return I18n.t('estimate');
    case 'billing':
      return I18n.t('billing2');
    default:
      return '';
  }
}

function getObservationByCompany(empName) {
  switch (empName) {
    case 'nortel':
      return I18n.t('observationTextNortel');
    default:
      return I18n.t('observationText');
  }
}

function getObservationMinMax(empName) {
  switch (empName) {
    case 'nortel':
      return inputs.observationNortel;
    default:
      return inputs.observation;
  }
}

function renderCheckoutResumePrice(props = {}) {
  const {
    cartItems, taxName = 'ST', hasTax, taxType, taxFixedValue, companyTag,
  } = props;

  const valueItems = CartUtil.getCartTotal(cartItems, true, undefined, undefined, companyTag);

  const taxes = CartUtil.getCartTax(cartItems, taxType, {
    hasTax, taxFixedValue,
  }, companyTag);

  const total = valueItems + taxes;

  return (
    <React.Fragment>
      <div className="resume-content">
        <span>{I18n.t('subTotal')}</span>
        <span><PriceComponent value={valueItems} /></span>
      </div>
      {!!(taxes && taxName) && (
        <div className="resume-content">
          <strong>{taxName}</strong>
          <strong><PriceComponent value={taxes} /></strong>
        </div>
      )}
      <div className="resume-content">
        <strong>{I18n.t('total')}</strong>
        <strong><PriceComponent value={total} /></strong>
      </div>
    </React.Fragment>
  );
}

function validatesObservation(props = {}, value) {
  const { isLocker, observation } = props;
  if (isLocker && (value.indexOf('Cliente Retira no LOCKER - ') < 0)) {
    if (observation.indexOf('Cliente Retira no LOCKER - ') < 0) {
      props.setObservation(`Cliente Retira no LOCKER - ${value}`);
    }
  } else {
    props.setObservation(value);
  }
}

const CheckoutResume = (props) => {
  const {
    selectedContract, cartItems, payment, address, clientNumber, minimumBillingDate,
    pricePermission, deliveryDays, observation, visibleResume, isClient, isLocker, companyTag,
    leadTimePermission, stockPermission, opicCodePermission, soneparCodePermission, soneparCodeOff,
    cartId, deliveryAddress, cartUser,
  } = props;

  const company = companyTag || '';
  const inputObs = getObservationMinMax(company);

  const paymentTerms = selectedContract.clientDetails && selectedContract.clientDetails.paymentTermsLabel
    && selectedContract.clientDetails.paymentTermsLabel.description;

  if (company) {
    return (
      <React.Fragment>
        {cartUser && (
          <div className="resume">
            <span className="resume-title">{I18n.t('requestUserInformation')}</span>
            <div className="resume-content">
              <div className="txt">
                <p className="txt-title">{I18n.t('requestUserName')}</p>
                <span>{cartUser.name}</span>
                <p style={{ marginTop: '20px' }} className="txt-title">{I18n.t('requestUserEmail')}</p>
                <span>{cartUser.email}</span>
              </div>
            </div>
          </div>
        )}
        {!!(cartItems && cartItems.length) && (
          <div className="resume">
            <div className="basket">

              <div className="basket-title-product">
                <div className="coll-01">{I18n.t('product')}</div>
                <div className="coll-02" />
                <div className="coll-03">{pricePermission ? I18n.t('price') : ''}</div>
                <div className="coll-04">{I18n.t('quantity')}</div>
                <div className="coll-05">{pricePermission ? I18n.t('subTotal') : ''}</div>
              </div>

              {cartItems.map((item, index) => (
                <CartTableItem
                  key={item.product.id}
                  item={item}
                  pricePermission={pricePermission}
                  leadTimePermission={leadTimePermission}
                  stockPermission={stockPermission}
                  opicCodePermission={opicCodePermission}
                  soneparCodePermission={soneparCodePermission}
                  soneparCodeOff={soneparCodeOff}
                  isCheckout
                  clickLocation={I18n.t('checkout')}
                  clickPosition={index}
                />
              ))}
            </div>
          </div>
        )}

        {!!address && (
          <div className="resume">
            <span className="resume-title">{I18n.t('deliveryType')}</span>

            <div className="resume-content">
              <div className="ico">
                {(isClient || isLocker) ? (
                  <svg className="icon icon-fazer-compras"><use xlinkHref="#icon-fazer-compras" /></svg>
                ) : (
                  <svg className="icon icon-caminhao"><use xlinkHref="#icon-caminhao" /></svg>
                )}
              </div>
              <div className="txt">
                <span className="txt-title">
                  {
                    // eslint-disable-next-line no-nested-ternary
                    I18n.t(isClient
                      ? 'storeTake'
                      : (isLocker)
                        ? 'pickUpAtLockerStore'
                        : 'normalDelivery')
                  }
                </span>
                {(isClient || isLocker) ? address.name : address.nameAbbr}
                {' '}
                <br />
                {address.address}
                {' '}
                <br />
                {address.province}
                {' '}
                <br />
                {`${address.city} - ${address.state}`}
                <br />
                {`${NUMBER.cepMask(address.cep)} - ${address.country}`}
              </div>
              {(!cartId || (cartId && !deliveryAddress)) && (
                <button
                  type="button"
                  className="btn"
                  onClick={() => props.changeAddress()}
                >
                  {I18n.t('changeAddress')}
                </button>
              )}
            </div>

          </div>
        )}

        {/* Prazo de entrega removido temporariamente
        {(address && deliveryDays) ? (
          <div>
            <h4>
              <div className="checkout-resume">
                <Translate value="estimateTime" />
              </div>
            </h4>
            <p>
              {deliveryDays}
              {' '}
              <Translate value="workingDays" />
            </p>
          </div>
        ) : ''} */}

        {!!(payment && payment.type) && (
          <div className="resume">
            <span className="resume-title">{I18n.t('paymentType')}</span>

            <div className="resume-content">
              <div className="txt">
                <span className="txt-title">{getPaymentLabel(payment.type)}</span>
                {paymentTerms && payment.type === 'billing' ? `${paymentTerms}` : ''}
              </div>
              <button
                type="button"
                className="btn"
                onClick={() => props.changePayment()}
              >
                {I18n.t('changePayment')}
              </button>
            </div>

          </div>
        )}

        {minimumBillingDate && (
          <div className="resume">
            <span className="resume-title">
              {I18n.t('minimumBillingDate')}
              <span className="billingTooltip" title={I18n.t('billingDateTooltip')}> (?)</span>
            </span>
            <p>{moment(minimumBillingDate).format('DD/MM/YYYY')}</p>
          </div>
        )}

        {clientNumber && (
          <div className="resume">
            <span className="resume-title">{I18n.t('orderCodeOptional')}</span>
            {clientNumber}
          </div>
        )}

        {pricePermission ? (
          <div className="resume">
            <span className="resume-title">{I18n.t('total')}</span>

            {renderCheckoutResumePrice(props)}

            <label className="lbl-txt">
              {getObservationByCompany(company)}
              <textarea
                rows={4}
                value={observation}
                onChange={text => validatesObservation(props, text.target.value)}
                minLength={inputObs.min}
                maxLength={inputObs.max}
              />
            </label>

          </div>
        ) : (
          <div className="resume">
            <span className="resume-title">{getObservationByCompany(company)}</span>
            <label className="lbl-txt">
              <textarea
                rows={4}
                value={observation}
                onChange={text => validatesObservation(props, text.target.value)}
                minLength={inputObs.min}
                maxLength={inputObs.max}
              />
            </label>
          </div>
        )}

      </React.Fragment>
    );
  }
};

const mapStateToProps = (state, ownProps) => ({
  selectedContract: state.contracts.selected,
  clientNumber: state.cart.clientNumber,
  observation: state.cart.observation,
  minimumBillingDate: state.cart.minimumBillingDate,
  address:
    ownProps.address
    && (ownProps.address.isClient || ownProps.address.isLocker
      ? state.contracts.selected.clientDetails.location
      : state.contracts.selected.client.locations.find(
        a => a.nameAbbr === ownProps.address.nameAbbr
            && a.cep === ownProps.address.cep
            && a.deliveryCode === ownProps.address.deliveryCode,
      )),
  pricePermission:
    state.contracts.selected && state.contracts.selected.pricePermission,
  leadTimePermission:
    state.contracts.selected && state.contracts.selected.leadTimePermission,
  stockPermission:
    !state.contracts.selected
    || (state.contracts.selected && state.contracts.selected.stockPermission),
  opicCodePermission:
    state.contracts.selected && state.contracts.selected.opicCodePermission,
  soneparCodePermission:
    state.contracts.selected && state.contracts.selected.soneparCodePermission,
  soneparCodeOff: !!state.settings.soneparCodeOff,
  deliveryDays: Number(state.settings.deliveryDays),
  isClient: ownProps.address && ownProps.address.isClient,
  isLocker: ownProps.address && ownProps.address.isLocker,
  companyTag: state.settings.companyTag,
  taxName: state.settings && state.settings.taxName,
  taxType: state.settings && state.settings.taxType,
  taxFixedValue: Number(state.settings && state.settings.taxFixedValue, 0),
  cartId: state.cart && state.cart.cartId,
  deliveryAddress: state.cart && state.cart.deliveryAddress,
  cartUser: state.cart && state.cart.user,
});

const mapDispatchToProps = dispatch => ({
  setObservation: text => dispatch(setObservation(text)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CheckoutResume);
